import { render } from "./WhatsAppSettingsView.vue?vue&type=template&id=c59ce3d6&scoped=true"
import script from "./WhatsAppSettingsView.vue?vue&type=script&lang=js"
export * from "./WhatsAppSettingsView.vue?vue&type=script&lang=js"

import "./WhatsAppSettingsView.vue?vue&type=style&index=0&id=c59ce3d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c59ce3d6"]])

export default __exports__